import { tmResources, TM_FRAUD_SOURCE_IDS } from './GlobalConstant';

export const returnFraudUserAccess = (authenticationData) => {
  // declare bool variables
  let isFraud = false;
  let isTMuser = false;

  // loop through the authentication data for the necessary flagging
  authenticationData.forEach((data) => {
    let accessCode = data.details.resource.resourceCode;
    if (accessCode === tmResources.APP_3_RESOURCE_UI_TM_IAD_FULLACCESS) {
      data.attributes.forEach((attribute) => {
        if (
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.TM) &&
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD)
        ) {
          isFraud = true;
          isTMuser = true;
        } else if (attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.TM)) {
          isTMuser = true;
        } else if (
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD)
        ) {
          isFraud = true;
        }
      });
    }
  });

  return {
    isTMuser,
    isFraud
  };
};

export const returnFraudUserAccessByResource = (
  authenticationData,
  resourceCode
) => {
  // declare bool variables
  let isFraud = false;
  let isFraudPrevention = false;
  let isTMuser = false;
  let isRTUser = false;

  // loop through the authentication data for the necessary flagging
  authenticationData.forEach((data) => {
    let accessCode = data.details.resource.resourceCode;
    if (accessCode === resourceCode) {
      data.attributes.forEach((attribute) => {
        if (attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.TM)) {
          isTMuser = true;
        }
        if (attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD)) {
          isFraud = true;
        }
        if (
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID)
        ) {
          isFraudPrevention = true;
          isRTUser = true;
        }
      });
    }
  });

  return {
    isTMuser,
    isFraud,
    isFraudPrevention,
    isRTUser
  };
};
